// <---Actions for Common --->

//snackbar
export const TOASTER = {
  TOASTER_TRIGGER: "trigger",
  TOASTER_SHOW: "show",
};

//loader
export const LOADER = {
  LOADER_TRIGGER: "loader-trigger",
  LOADER_SHOW: "loader-show",
};

//date range picker
export const DATE_RANGEPICKER = {
  DATE_RANGEPICKER_VALUE: "date-rangepicker-value",
};

//Search Query Parameter
export const SEARCH_QUERY = {
  SEARCH_QUERY_VALUE: "search_query_value",
};

// <-------- API Actions ------>

//Login Action
export const GET_LOGIN = {
  GET_LOGIN_REQUESTED: "GET_LOGIN_REQUESTED",
  GET_LOGIN_SUCCESS: "GET_LOGIN_SUCCESS",
  GET_LOGIN_FAILED: "GET_LOGIN_FAILED",
};

export const POST_LOGOUT = {
  POST_LOGOUT_REQUESTED: "POST_LOGOUT_REQUESTED",
  POST_LOGOUT_SUCCESS: "POST_LOGOUT_SUCCESS",
  POST_LOGOUT_FAILED: "POST_LOGOUT_FAILED",
};

//Otp Action
export const GET_OTP = {
  GET_OTP_REQUESTED: "GET_OTP_REQUESTED",
  GET_OTP_SUCCESS: "GET_OTP_SUCCESS",
  GET_OTP_FAILED: "GET_OTP_FAILED",
};

//Country List
export const GET_COUNTRYCODE = {
  GET_COUNTRYCODE_REQUESTED: "GET_COUNTRYCODE_REQUESTED",
  GET_COUNTRYCODE_SUCCESS: "GET_COUNTRYCODE_SUCCESS",
  GET_COUNTRYCODE_FAILED: "GET_COUNTRYCODE_FAILED",
};

//Company Front desk

export const GET_BOOKINGLIST = {
  GET_BOOKINGLIST_REQUESTED: "GET_BOOKINGLIST_REQUESTED",
  GET_BOOKINGLIST_SUCCESS: "GET_BOOKINGLIST_SUCCESS",
  GET_BOOKINGLIST_FAILED: "GET_BOOKINGLIST_FAILED",
};

export const GET_BOOKINGDETAILS = {
  GET_BOOKINGDETAILS_REQUESTED: "GET_BOOKINGDETAILS_REQUESTED",
  GET_BOOKINGDETAILS_SUCCESS: "GET_BOOKINGDETAILS_SUCCESS",
  GET_BOOKINGDETAILS_FAILED: "GET_BOOKINGDETAILS_FAILED",
  GET_BOOKINGDETAILS_RESET: "GET_BOOKINGDETAILS_RESET",
};

export const GET_ADDBOOKING = {
  GET_ADDBOOKING_REQUESTED: "GET_ADDBOOKING_REQUESTED",
  GET_ADDBOOKING_SUCCESS: "GET_ADDBOOKING_SUCCESS",
  GET_ADDBOOKING_FAILED: "GET_ADDBOOKING_FAILED",
};

export const GET_BOOKINGBUFFERTIME = {
  GET_BOOKINGBUFFERTIME_REQUESTED: "GET_BOOKINGBUFFERTIME_REQUESTED",
  GET_BOOKINGBUFFERTIME_SUCCESS: "GET_BOOKINGBUFFERTIME_SUCCESS",
  GET_BOOKINGBUFFERTIME_FAILED: "GET_BOOKINGBUFFERTIME_FAILED",
};

export const GET_AIRPORTTERMINALLIST = {
  GET_AIRPORTTERMINALLIST_REQUESTED: "GET_AIRPORTTERMINALLIST_REQUESTED",
  GET_AIRPORTTERMINALLIST_SUCCESS: "GET_AIRPORTTERMINALLIST_SUCCESS",
  GET_AIRPORTTERMINALLIST_FAILED: "GET_AIRPORTTERMINALLIST_FAILED",
};

export const GET_UPDATEBOOKING = {
  GET_UPDATEBOOKING_REQUESTED: "GET_UPDATEBOOKING_REQUESTED",
  GET_UPDATEBOOKING_SUCCESS: "GET_UPDATEBOOKING_SUCCESS",
  GET_UPDATEBOOKING_FAILED: "GET_ADDBOOKING_FAILED",
};

export const GET_CANCELREASSON = {
  GET_CANCELREASSON_REQUESTED: "GET_CANCELREASSON_REQUESTED",
  GET_CANCELREASSON_SUCCESS: "GET_CANCELREASSON_SUCCESS",
  GET_CANCELREASSON_FAILED: "GET_CANCELREASSON_FAILED",
};

export const GET_EMPLOYEESLIST = {
  GET_EMPLOYEESLIST_REQUESTED: "GET_EMPLOYEESLIST_REQUESTED",
  GET_EMPLOYEESLIST_SUCCESS: "GET_EMPLOYEESLIST_SUCCESS",
  GET_EMPLOYEESLIST_FAILED: "GET_EMPLOYEESLIST_FAILED",
};

export const GET_EMPLOYEEDETAILS = {
  GET_EMPLOYEEDETAILS_REQUESTED: "GET_EMPLOYEEDETAILS_REQUESTED",
  GET_EMPLOYEEDETAILS_SUCCESS: "GET_EMPLOYEEDETAILS_SUCCESS",
  GET_EMPLOYEEDETAILS_FAILED: "GET_EMPLOYEEDETAILS_FAILED",
  GET_EMPLOYEEDETAILS_RESET: "GET_EMPLOYEEDETAILS_RESET",
};

export const GET_ADDEMPLOYEE = {
  GET_ADDEMPLOYEE_REQUESTED: "GET_ADDEMPLOYEE_REQUESTED",
  GET_ADDEMPLOYEE_SUCCESS: "GET_ADDEMPLOYEE_SUCCESS",
  GET_ADDEMPLOYEE_FAILED: "GET_ADDEMPLOYEE_FAILED",
};

export const GET_UPDATEEMPLOYEE = {
  GET_UPDATEEMPLOYEE_REQUESTED: "GET_UPDATEEMPLOYEE_REQUESTED",
  GET_UPDATEEMPLOYEE_SUCCESS: "GET_UPDATEEMPLOYEE_SUCCESS",
  GET_UPDATEEMPLOYEE_FAILED: "GET_UPDATEEMPLOYEE_FAILED",
};

export const UPLOAD_EMPLOYEE_EXCEL = {
  UPLOAD_EMPLOYEE_EXCEL_REQUESTED: "UPLOAD_EMPLOYEE_EXCEL_REQUESTED",
  UPLOAD_EMPLOYEE_EXCEL_SUCCESS: "UPLOAD_EMPLOYEE_EXCEL_SUCCESS",
  UPLOAD_EMPLOYEE_EXCEL_FAILED: "UPLOAD_EMPLOYEE_EXCEL_FAILED",
  UPLOAD_EMPLOYEE_EXCEL_RESET: "UPLOAD_EMPLOYEE_EXCEL_RESET",
};

export const APPROVE_EMPLOYEE = {
  APPROVE_EMPLOYEE_REQUESTED: "APPROVE_EMPLOYEE_REQUESTED",
  APPROVE_EMPLOYEE_SUCCESS: "APPROVE_EMPLOYEE_SUCCESS",
  APPROVE_EMPLOYEE_FAILED: "APPROVE_EMPLOYEE_FAILED",
};

// Add Service City Action
export const GET_SERVICECITY = {
  GET_SERVICECITY_REQUESTED: "GET_SERVICECITY_REQUESTED",
  GET_SERVICECITY_SUCCESS: "GET_SERVICECITY_SUCCESS",
  GET_SERVICECITY_FAILED: "GET_SERVICECITY_FAILED",
};

//USER DUTY TYPE
export const GET_DUTYTYPE = {
  GET_DUTYTYPE_REQUESTED: "GET_DUTYTYPE_REQUESTED",
  GET_DUTYTYPE_SUCCESS: "GET_DUTYTYPE_SUCCESS",
  GET_DUTYTYPE_FAILED: "GET_DUTYTYPE_FAILED",
};

//Car
export const GET_CAR = {
  GET_CAR_REQUESTED: "GET_CAR_REQUESTED",
  GET_CAR_SUCCESS: "GET_CAR_SUCCESS",
  GET_CAR_FAILED: "GET_CAR_FAILED",
};

//User Profile
export const GET_PROFILE = {
  GET_PROFILE_REQUESTED: "GET_PROFILE_REQUESTED",
  GET_PROFILE_SUCCESS: "GET_PROFILE_SUCCESS",
  GET_PROFILE_FAILED: "GET_PROFILE_FAILED",
};

// Company Profile
export const GET_COMPANY_DETAILS = {
  GET_COMPANY_DETAILS_REQUESTED: "GET_COMPANY_DETAILS_REQUESTED",
  GET_COMPANY_DETAILS_SUCCESS: "GET_COMPANY_DETAILS_SUCCESS",
  GET_COMPANY_DETAILS_FAILED: "GET_COMPANYDETAILS_FAILED",
};

export const GET_COMPANY_LOGO = {
  GET_COMPANY_LOGO_REQUESTED: "GET_COMPANY_LOGO_REQUESTED",
  GET_COMPANY_LOGO_SUCCESS: "GET_COMPANY_LOGO_SUCCESS",
  GET_COMPANY_LOGO_FAILED: "GET_COMPANY_LOGO_FAILED",
};

export const GET_PARENT_COMPANYLIST = {
  GET_PARENT_COMPANYLIST_REQUESTED: "GET_PARENT_COMPANYLIST_REQUESTED",
  GET_PARENT_COMPANYLIST_SUCCESS: "GET_PARENT_COMPANYLIST_SUCCESS",
  GET_PARENT_COMPANYLIST_FAILED: "GET_PARENT_COMPANYLIST_FAILED",
};

// Rate Card
//Get Rate Card Action
export const GET_RATECARD = {
  GET_RATECARD_REQUESTED: "GET_RATECARD_REQUESTED",
  GET_RATECARD_SUCCESS: "GET_RATECARD_SUCCESS",
  GET_RATECARD_FAILED: "GET_RATECARD_FAILED",
  GET_RATECARD_CLEARED: "GET_RATECARD_CLEARED",
};

//Add Rate Card Action
//Add Rate Card Action
export const GET_ADDRATECARD = {
  GET_ADDRATECARD_REQUESTED: "GET_ADDRATECARD_REQUESTED",
  GET_ADDRATECARD_SUCCESS: "GET_ADDRATECARD_SUCCESS",
  GET_ADDRATECARD_FAILED: "GET_ADDRATECARD_FAILED",
};

// Get Trip Price
export const GET_TRIPPRICE = {
  GET_TRIPPRICE_REQUESTED: " GET_TRIPPRICE_REQUESTED",
  GET_TRIPPRICE_SUCCESS: " GET_TRIPPRICE_SUCCESS",
  GET_TRIPPRICE_FAILED: " GET_TRIPPRICE_FAILED",
};

// Company DutyType
export const GET_COMPANYDUTY = {
  GET_COMPANYDUTY_REQUESTED: " GET_COMPANYDUTY_REQUESTED",
  GET_COMPANYDUTY_SUCCESS: " GET_COMPANYDUTY_SUCCESS",
  GET_COMPANYDUTY_FAILED: " GET_COMPANYDUTY_FAILED",
  GET_COMPANYDUTY_CLEAR: " GET_COMPANYDUTY_CLEAR",
};

// Company Location
export const GET_COMPANYLOCATION = {
  GET_COMPANYLOCATION_REQUESTED: " GET_COMPANYLOCATION_REQUESTED",
  GET_COMPANYLOCATION_SUCCESS: " GET_COMPANYLOCATION_SUCCESS",
  GET_COMPANYLOCATION_FAILED: " GET_COMPANYLOCATION_FAILED",
  GET_COMPANYLOCATION_CLEAR: " GET_COMPANYLOCATION_CLEAR",
};

// SubCity Location
export const GET_SUBCITY = {
  GET_SUBCITY_REQUESTED: "GET_SUBCITY_REQUESTED",
  GET_SUBCITY_SUCCESS: "GET_SUBCITY_SUCCESS",
  GET_SUBCITY_FAILED: "GET_SUBCITY_FAILED",
  GET_SUBCITY_CLEAR: "GET_SUBCITY_CLEAR",
};

//Get Rate Calculation Action
export const GET_RATECALCULATION = {
  GET_RATECALCULATION_REQUESTED: "GET_RATECALCULATION_REQUESTED",
  GET_RATECALCULATION_SUCCESS: "GET_RATECALCULATION_SUCCESS",
  GET_RATECALCULATION_FAILED: "GET_RATECALCULATION_FAILED",
  GET_RATECALCULATION_CLEARED: "GET_RATECALCULATION_CLEARED",
};

//Google Map AutoComplete
export const GET_GOOGLEAUTOSUGGESTIONS = {
  GET_GOOGLEAUTOSUGGESTIONS_REQUESTED: "GET_GOOGLEAUTOSUGGESTIONS_REQUESTED",
  GET_GOOGLEAUTOSUGGESTIONS_SUCCESS: "GET_GOOGLEAUTOSUGGESTIONS_SUCCESS",
  GET_GOOGLEAUTOSUGGESTIONS_FAILED: "GET_GOOGLEAUTOSUGGESTIONS_FAILED",
  GET_GOOGLEAUTOSUGGESTIONS_CLEARED: "GET_GOOGLEAUTOSUGGESTIONS_CLEARED",
};

//Google Map Place details
export const GET_GOOGLEMAPPLACEDETAILS = {
  GET_GOOGLEMAPPLACEDETAILS_REQUESTED: "GET_GOOGLEMAPPLACEDETAILS_REQUESTED",
  GET_GOOGLEMAPPLACEDETAILS_SUCCESS: "GET_GOOGLEMAPPLACEDETAILS_SUCCESS",
  GET_GOOGLEMAPPLACEDETAILS_FAILED: "GET_GOOGLEMAPPLACEDETAILS_FAILED",
  GET_GOOGLEMAPPLACEDETAILS_CLEARED: "GET_GOOGLEMAPPLACEDETAILS_CLEARED",
  GET_GOOGLEMAPPLACEDETAILSPICKUP_SUCCESS:
    "GET_GOOGLEMAPPLACEDETAILSPICKUP_SUCCESS",
  GET_GOOGLEMAPPLACEDETAILSDROP_SUCCESS:
    "GET_GOOGLEMAPPLACEDETAILSDROP_SUCCESS",
  GET_GOOGLEMAPPLACEDETAILSLANDMARK_SUCCESS:
    "GET_GOOGLEMAPPLACEDETAILSLANDMARK_SUCCESS",
};

//Google Map Direction details
export const GET_GOOGLEMAPDIRECTION = {
  GET_GOOGLEMAPDIRECTION_REQUESTED: "GET_GOOGLEMAPDIRECTION_REQUESTED",
  GET_GOOGLEMAPDIRECTION_SUCCESS: "GET_GOOGLEMAPDIRECTION_SUCCESS",
  GET_GOOGLEMAPDIRECTION_FAILED: "GET_GOOGLEMAPDIRECTION_FAILED",
};

//Google Map Geocode details
export const GET_GEOCODE = {
  GET_GEOCODE_REQUESTED: "GET_GEOCODE_REQUESTED",
  GET_GEOCODE_SUCCESS: "GET_GEOCODE_SUCCESS",
  GET_GEOCODE_FAILED: "GET_GEOCODE_FAILED",
};

//Cancel Trip
export const GET_CANCELTRIP = {
  GET_CANCELTRIP_REQUESTED: "GET_CANCELTRIP_REQUESTED",
  GET_CANCELTRIP_SUCCESS: "GET_CANCELTRIP_SUCCESS",
  GET_CANCELTRIP_FAILED: "GET_CANCELTRIP_FAILED",
};

export const GET_CANCELCHARGES = {
  GET_CANCELCHARGES_REQUESTED: "GET_CANCELCHARGES_REQUESTED",
  GET_CANCELCHARGES_SUCCESS: "GET_CANCELCHARGES_SUCCESS",
  GET_CANCELCHARGES_FAILED: "GET_CANCELCHARGES_FAILED",
};

export const GET_BILLING = {
  GET_BILLING_REQUESTED: "GET_BILLING_REQUESTED",
  GET_BILLING_SUCCESS: "GET_BILLING_SUCCESS",
  GET_BILLING_FAILED: "GET_BILLING_FAILED",
};

export const GET_BILLINGAPPROVAL = {
  GET_BILLINGAPPROVAL_REQUESTED: "GET_BILLINGAPPROVAL_REQUESTED",
  GET_BILLINGAPPROVAL_SUCCESS: "GET_BILLINGAPPROVAL_SUCCESS",
  GET_BILLINGAPPROVAL_FAILED: "GET_BILLINGAPPROVAL_FAILED",
};

//Comapny City
export const GET_COMPANYCITY = {
  GET_COMPANYCITY_REQUESTED: "GET_COMPANYCITY_REQUESTED",
  GET_COMPANYCITY_SUCCESS: "GET_COMPANYCITY_SUCCESS",
  GET_COMPANYCITY_FAILED: "GET_COMPANYCITY_FAILED",
};

//Comapny Service
export const GET_COMPANYSERVICE = {
  GET_COMPANYSERVICE_REQUESTED: "GET_COMPANYSERVICE_REQUESTED",
  GET_COMPANYSERVICE_SUCCESS: "GET_COMPANYSERVICE_SUCCESS",
  GET_COMPANYSERVICE_FAILED: "GET_COMPANYSERVICE_FAILED",
};

// Car Facilities
export const GET_CARFACILTIES = {
  GET_CARFACILTIES_REQUESTED: " GET_CARFACILTIES_REQUESTED",
  GET_CARFACILTIES_SUCCESS: " GET_CARFACILTIES_SUCCESS",
  GET_CARFACILTIES_FAILED: " GET_CARFACILTIES_FAILED",
};

// Dashboard Details
export const GET_RIDE_DETAILS = {
  GET_RIDE_DETAILS_REQUESTED: "GET_RIDE_DETAILS_REQUESTED",
  GET_RIDE_DETAILS_SUCCESS: "GET_RIDE_DETAILS_SUCCESS",
  GET_RIDE_DETAILS_FAILED: "GET_RIDE_DETAILS_FAILED",
};

export const ACCOUNT_DELETION = {
  ACCOUNT_DELETION_REQUESTED: "ACCOUNT_DELETION_REQUESTED",
  ACCOUNT_DELETION_SUCCESS: "ACCOUNT_DELETION_SUCCESS",
  ACCOUNT_DELETION_FAILED: "ACCOUNT_DELETION_FAILED",
};

export const CANCEL_PAYMENT_LINK = {
  CANCEL_PAYMENT_LINK_REQUESTED: "CANCEL_PAYMENT_LINK_REQUESTED",
  CANCEL_PAYMENT_LINK_SUCCESS: "CANCEL_PAYMENT_LINK_SUCCESS",
  CANCEL_PAYMENT_LINK_FAILED: "CANCEL_PAYMENT_LINK_FAILED",
};
